import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import { formatMoney as baseFormatMoney, type FormatMoneyOptions } from '../utils/format-money';

type FormatMoneyHookOptions = Omit<FormatMoneyOptions, 'locale'> & {
  locale?: string;
};

export function useMoneyFormatter(locale?: string): {
  formatMoney: (options: FormatMoneyHookOptions) => string;
} {
  const intl = useIntl();
  const resolvedLocale = locale || intl.locale;

  return useMemo(
    () => ({
      formatMoney: (options: FormatMoneyHookOptions): string => {
        return baseFormatMoney({
          ...options,
          locale: resolvedLocale,
        });
      },
    }),
    [resolvedLocale]
  );
}
